import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const passbookPromise = import("./Passbook");
export default Auth(lazy(() => passbookPromise));
